import { defineComponent, createElementBlock, openBlock, unref, createElementVNode, createVNode, createCommentVNode, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es149.js';
/* empty css                        */

const _hoisted_1 = ["data-version"];
const _hoisted_2 = { class: "distraction-free-footer__inner" };
const _hoisted_3 = { class: "distraction-free-footer__copyright" };
const _hoisted_4 = { key: 0 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DistractionFreeFooter",
  props: {
    navLegalItems: {},
    copyright: {},
    copyrightTagline: {}
  },
  setup(__props) {
    const packageJsonVersion = '"0.65.4"';
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("footer", {
        class: "distraction-free-footer",
        "data-version": unref(packageJsonVersion) || "unknown"
      }, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            createElementVNode("span", null, toDisplayString(props.copyright), 1),
            props.copyrightTagline ? (openBlock(), createElementBlock("span", _hoisted_4, toDisplayString(props.copyrightTagline), 1)) : createCommentVNode("", true)
          ]),
          createVNode(_sfc_main$1, {
            items: props.navLegalItems,
            class: "distraction-free-footer__nav-legal"
          }, null, 8, ["items"])
        ])
      ], 8, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
